<template>
    <div :ref="stepName" style="position:relative">
        <div class="form-header satisfaction">
            <strong>Que se passe-t-il après mon inscription ?</strong>
            <ul class="satisfaction-list">
                <li class="satisfaction-list-item">
                    <div>
                        <img :src="satisfaction_data[0].image" alt="Satisfaction icon">
                        <p class="colored" v-html="satisfaction_data[0].question"></p>
                        <p class="colored uppercase" v-html="satisfaction_data[0].result"></p>
                    </div>
                    <div>
                        <p v-for="text_item in satisfaction_data[0].text" v-html="text_item" class="text"></p>
                    </div>
                </li>
                <li class="satisfaction-list-item">
                    <div class="line"></div>
                </li>
                <li class="satisfaction-list-item opposite">
                    <div>
                        <img :src="satisfaction_data[1].image" alt="Satisfaction icon">
                        <p class="colored" v-html="satisfaction_data[1].question"></p>
                        <p class="colored uppercase" v-html="satisfaction_data[1].result"></p>
                    </div>
                    <div>
                        <p v-for="text_item in satisfaction_data[1].text" v-html="text_item" class="text"></p>
                    </div>
                </li>
            </ul>
            <p><span>Si vous êtes satisfait :</span></p>
            <p>Grâce à notre <span>offre découverte</span>, si vous êtes satisfait de votre abonnement après 6 mois :</p>
            <ul class="satisfaction-result-list">
                <li class="satisfaction-result-list-item" v-for="(item, n) in satisfaction_result" :key="n">
                    <p v-html="item"></p>
                </li>
            </ul>
        </div>
        <b-button type="button is-primary next-button" :disabled="block_form" v-html="step._button" @click="nextStep()"></b-button>
        <b-loading :is-full-page="false" v-model="loading"></b-loading>
    </div>
</template>

<script>
import mixin from "../../../travel_step_mixin";
import form_step_mixin from '../../../form_step_mixin'
import {Text} from "../../../../../../models/fields/Text";
import SatisfactionForm from "./SatisfactionForm.vue";
import animation_engine_mixin from "../../../animation_engine_mixin";
import animation_step_style_mixin from "../../../animation_step_style_mixin";

export default {
    components: {SatisfactionForm},
    mixins: [mixin,  animation_engine_mixin, animation_step_style_mixin, form_step_mixin],
    data() {
        return {
            satisfaction_data: [
                {
                    image: '/images/icons/happy_emoji.svg',
                    question: 'Satisfait ?',
                    result: 'Je profite de 3 mois à 0€',
                    text: ['Je reçois mon cadeau au choix', 'Je bénéficie de mes avantages à 50% pendant 1 an']
                },
                {
                    image: '/images/icons/sad_emoji.svg',
                    question: 'Pas convaincu ?',
                    result: 'Je résilie à tout moment et sans frais',
                    text: ['Je n’ai plus d’accès aux nombreux avantages membres']
                }
            ],
            satisfaction_result: [
                "Vous serez remboursé de vos 3 premières mensualités à 9,84 €, ce qui correspond à trois mois d’abonnement gratuits.",
                "En plus de cela, dès que vous avez réglé votre deuxième mensualité, vous pourrez déjà sélectionner un cadeau parmi notre vaste gamme de plus de cent produits. Que vous soyez amateur de high-tech, d'articles pour la maison ou d’accessoires pratiques, il y a forcément un cadeau qui vous conviendra !",
                "Vous continuez à profiter de votre abonnement, mais à un tarif réduit de 50%",
                "Vous ne paierez que 9,84 € par mois au lieu de 19,68 € pendant la première année, ce qui vous permet de continuer à bénéficier de tous les avantages, à un coût réduit"
            ]
        }
    }
}
</script>
